import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import SchoolLayout from './components/SchoolLayout'
import Login from './pages/Login'
import Register from './pages/Register'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import SchoolLegalTerms from './pages/SchoolLegalTerms'
import VerifyEmail from './pages/VerifyEmail'
import CreateSchool from './pages/CreateSchool'
import ForgotPassword from './pages/ForgotPassword'
import VerifyOTP from './pages/VerifyOTP'
import ResetPassword from './pages/ResetPassword'
import ClaimProfileStart from './pages/ClaimProfileStart'
import ClaimProfile from './pages/ClaimProfile'
import Dashboard from './pages/Dashboard'
import Profile from './pages/Profile'
import EditSchoolDocuments from './pages/EditSchoolDocuments'
import Courses from './pages/Courses'
import CreateCourse from './pages/CreateCourse'
import CourseDetails from './pages/CourseDetails'
import Media from './pages/Media'
import Bookings from './pages/Bookings'
import BookingDetails from './pages/BookingDetails'
import Rooms from './pages/Rooms'
import RoomDetail from './pages/RoomDetail'
import DocumentationLayout from './components/DocumentationLayout'
import GettingStarted from './pages/documentation/GettingStarted'
import ListingSchool from './pages/documentation/ListingSchool'
import PaymentTerms from './pages/documentation/PaymentTerms'
import FAQ from './pages/documentation/FAQ'
import Support from './pages/documentation/Support'
import TermsAndConditions from './pages/documentation/TermsAndConditions'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/legal" element={<SchoolLegalTerms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/create-school" element={<CreateSchool />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/claim-profile" element={<ClaimProfileStart />} />
        <Route path="/claim-profile/verify" element={<ClaimProfile />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <SchoolLayout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/profile/school-documents" element={<EditSchoolDocuments />} />
                  <Route path="/courses" element={<Courses />} />
                  <Route path="/courses/create" element={<CreateCourse />} />
                  <Route path="/courses/:courseId/edit" element={<CreateCourse />} />
                  <Route path="/courses/:courseId" element={<CourseDetails />} />
                  <Route path="/media" element={<Media />} />
                  <Route path="/bookings" element={<Bookings />} />
                  <Route path="/bookings/:id" element={<BookingDetails />} />
                  <Route path="/rooms" element={<Rooms />} />
                  <Route path="/rooms/:roomId" element={<RoomDetail />} />
                  <Route path="/documentation" element={<DocumentationLayout />}>
                    <Route index element={<Navigate to="/documentation/getting-started" replace />} />
                    <Route path="getting-started" element={<GettingStarted />} />
                    <Route path="listing-school" element={<ListingSchool />} />
                    <Route path="payment-terms" element={<PaymentTerms />} />
                    <Route path="faq" element={<FAQ />} />
                    <Route path="support" element={<Support />} />
                    <Route path="terms-and-conditions" element={<TermsAndConditions />} />
                  </Route>
                </Routes>
              </SchoolLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
